import { Clickable, H2, H3, List, P, Section } from '@ahmdigital/ui';
import classNames from 'classnames';

import constants from '../../../../../ahm-constants';
import styles from '../styles.module.sass';

const SupportSection = () => (
  <Section className={styles.section}>
    <H2 variant="marginBottomSpacer10">We’re here to help</H2>
    <P>
      We understand there are times our customers experience periods of vulnerability. We recognise these
      vulnerabilities can give rise to unique needs, which can change over time or in response to particular situations.
    </P>
    <P>
      If you require assistance when contacting us or interacting with our products and services, please see below for
      more information.
    </P>
    <P>
      We are committed to recognising, understanding, and supporting the needs of our Aboriginal and Torres Strait
      Islander customers, and customers from diverse cultural backgrounds.
    </P>
    <H3 looksLike="h4">Financial Hardship Support</H3>
    <P>
      If you’re experiencing financial hardship and are having difficulty meeting your premium payments, we’re here to
      help. We may agree to a short-term arrangement to assist during this difficult time. We ask that you let us know
      as soon as possible so we can help. Please get in touch on 1300 052 589 so we can talk through your options.
    </P>
    <P>
      The below are free external support services that may also be able to help if you or a loved one are experiencing
      financial hardship or navigating a challenging situation.
    </P>
    <List className={styles.list}>
      <li>
        <Clickable to={constants.URLS.THIRD_PARTY.LIFELINE}>Lifeline – 13 11 14</Clickable>
      </li>
      <li>
        <Clickable to={constants.URLS.THIRD_PARTY.NATIONAL_DEBT_HELPLINE}>National Debt Hotline 1800 007 007</Clickable>
      </li>
      <li>
        <Clickable to={constants.URLS.THIRD_PARTY.MONEYSMART}>MoneySmart</Clickable>
      </li>
    </List>
    <H3 looksLike="h4">Domestic & Family Violence</H3>
    <P>
      We believe in your right to be safe, and condemn domestic and family violence in all its forms. We also believe
      that safety is vital to your mental and physical health.
    </P>
    <P>
      We’re here if you need to speak to someone about your situation and what your options are for your cover. These
      ahm life insurance policies are issued by Hannover Life Re of Australasia Ltd (Hannover) and administered by
      Greenstone Financial Services Pty Ltd.
    </P>
    <List className={styles.list}>
      <li>
        Find out more about Greenstone Financial Services{' '}
        <Clickable to={constants.URLS.THIRD_PARTY.GREENSTONE_FAMILY_VIOLENCE_POLICY}>
          {' '}
          Domestic Family Violence Policy
        </Clickable>
      </li>
    </List>
    <H3 looksLike="h4">If you need additional assistance</H3>
    <List className={styles.list}>
      <li>
        <P>For hearing or speech difficulties, consider the National Relay Service (NRS)</P>
        <List className={classNames(styles.list, styles.nested)} variant={['compact', 'inside']}>
          <li>
            <P variant="marginBottomSpacerNone">
              Voice Relay number:{' '}
              <Clickable to={`tel:${constants.UI.CONTACT.PHONE.NATIONAL_RELAY_SERVICE.VOICE.STANDARD}`}>
                {constants.UI.CONTACT.PHONE.NATIONAL_RELAY_SERVICE.VOICE.PRETTY}
              </Clickable>
            </P>
            <Clickable to={constants.URLS.THIRD_PARTY.ACCESS_HUB_VOICE_RELAY} inNewTab>
              Voice Relay - Access Hub
            </Clickable>
          </li>

          <li>
            <P variant="marginBottomSpacerNone">
              TTY number:{' '}
              <Clickable to={`tel:${constants.UI.CONTACT.PHONE.NATIONAL_RELAY_SERVICE.TTY.STANDARD}`}>
                {constants.UI.CONTACT.PHONE.NATIONAL_RELAY_SERVICE.TTY.PRETTY}
              </Clickable>
            </P>
            <Clickable to={constants.URLS.THIRD_PARTY.ACCESS_HUB_TYPE_AND_LISTEN} inNewTab>
              TTY (Type and Listen) – Access Hub
            </Clickable>
          </li>

          <li>
            <P variant="marginBottomSpacerNone">
              SMS relay number:{' '}
              <Clickable to={`tel:${constants.UI.CONTACT.PHONE.NATIONAL_RELAY_SERVICE.SMS.STANDARD}`}>
                {constants.UI.CONTACT.PHONE.NATIONAL_RELAY_SERVICE.SMS.PRETTY}
              </Clickable>
            </P>
            <Clickable to={constants.URLS.THIRD_PARTY.ACCESS_HUB_SMS_RELAY} inNewTab>
              SMS Relay – Access Hub
            </Clickable>
          </li>
        </List>
      </li>
      <li>
        <P>
          If you have difficulties with English and would like an interpreting service, you may consider the{' '}
          <Clickable to={constants.URLS.THIRD_PARTY.TRANSLATING_AND_INTERPRETING_SERVICE} inNewTab>
            Translating and Interpreting Service (TIS National)
          </Clickable>
          .
        </P>
      </li>
    </List>
    <H3 looksLike="h4">Privacy</H3>
    <P>
      Your personal information will be handled in accordance with our{' '}
      <Clickable inNewTab to="https://static.ahm.com.au/files/life-insurance/privacy-collection-notice.pdf">
        Privacy Collection Notice
      </Clickable>
      . Click to access{' '}
      <Clickable to={constants.URLS.THIRD_PARTY.HANNOVER_RE_PRIVACY_POLICY}>Hannover’s Privacy Policy</Clickable>,
      <Clickable to={constants.URLS.THIRD_PARTY.GREENSTONE_PRIVACY_POLICY}>Greenstone’s Privacy Policy</Clickable> and{' '}
      <Clickable to={constants.URLS.SALES.PRIVACY}>ahm’s Privacy Policy</Clickable>.
    </P>
  </Section>
);

export default SupportSection;
